<template>
  <div>
    <headerSection></headerSection>

    <div id="main__content" class="">
      <div class="x-main-container">
        <div class="x-main-content">
          <!-- 'height':'100vh'-->
          <section
            class="x-index-top-container"
            :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}"
          >
            <div class="x-wrapper-right-container"></div>
            <div class="-index-inner-wrapper">
              <div class="-heading-wrapper js-replace-heading-wrapper">
                <h1 class="-title">
                  ระบบ Casino ที่ดีที่สุด มีแบรนด์ให้เลือกเล่นมากมาย
                </h1>
              </div>
              <swiper
                ref="mySwiper"
                :options="swiperOptions"
                style="padding-top:10px;padding-left:10px;padding-right:10px;"
              >
                <swiper-slide v-for="(item,index) in banners" :key="index">
                  <router-link to="/promotion">
                  <img
                    style="margin: auto;width: 650px;border-radius: 15px;"
                    class="img-fluid -slick-item -item-1"
                    :alt="item.name"
                    width="1200"
                    height="590"
                    :src="item.image"
                /></router-link>
                </swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              </swiper>
              <div class="d-lg-none" style="padding-top:10px;">
                <div class="x-feed-news-header">
                  <div
                    class="-feed-news-inner-wrapper animated fadeInUp"
                    data-animatable="fadeInUp"
                    data-delat="200"
                  >
                    <div class="-icon-container">
                      <i class="fas fa-volume-up"></i>
                    </div>

                    <div class="-track">
                      <div class="-track-item -duration-normal-content">
                        .. DeltaPlus+ ตัวตึงค่ายเกมส์ชั้นนำ สล็อตเข้าง่าย ได้เต็มคาราเบล บาคาร่าเปย์หนัก จัดเต็มทุกไม้ เล่นได้ จ่ายให้หมด รับสดกันเลย
                        ..
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="-games-provider-wrapper">
                <div class="-games-index-page">
                  <div
                    class="x-category-provider js-game-scroll-container js-game-container"
                  >
                    <div class="-top-paragraph">
                      <div class="container">
                        <div class="row">
                          <div class="col-12 px-2 px-lg-3">
                           <img src="../assets/images/title-shiba.png" alt="Deltaplus ศูนย์รวมแบรนด์ชั้นยอด อันดับ 1" style="width: 100%;max-width: 800px;height: auto;">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="-games-list-container container">
                      <nav class="nav-menu" id="navbarProvider">
                        <ul class="nav nav-pills">
                          <!-- <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                          <router-link to="/play" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="https://ufs888.s3.ap-southeast-1.amazonaws.com/deltaplus/menu/Menu-11.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ Deltaplus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                              href="javascript:void(0)"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              rel="nofollow noopener"
                              data-toggle="modal"
						                  data-target="#depositModal"
                              @click="checkPromotions()"
                            >
                              <picture>
                                <img
                                  src="https://ufs888.s3.ap-southeast-1.amazonaws.com/deltaplus/menu/Menu-01.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ Deltaplus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                               href="javascript:void(0)"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              data-toggle="modal"
						                  data-target="#withdrawModal"
                              @click="moveCreditToWallet()"
                            >
                              <picture>
                                <img
                                  src="https://ufs888.s3.ap-southeast-1.amazonaws.com/deltaplus/menu/Menu-02.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ Deltaplus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li> -->
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/promotion" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="../assets/images/menu/Menu-05.webp"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/history" class="nav-link js-account-approve-aware">
                              <picture>
                                <img
                                  src="../assets/images/menu/Menu-03.webp"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/partner" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="partner">
                                  <img
                                    src="../assets/images/menu/Menu-04.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-04.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/continue" class="nav-link js-account-approve-aware">
                              <picture>
                                  <template v-if="continueCheck">
                                  <img
                                    src="../assets/images/menu/Menu-06.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-06.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>

                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/cashback" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="cashback">
                                  <img
                                    src="../assets/images/menu/Menu-07.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-07.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >

                              <picture style="cursor: pointer;" @click="clickCheckin()">
                                <template v-if="checkin">
                                  <img
                                    src="../assets/images/menu/Menu-14.webp"
                                    alt="check-in DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-14.webp"
                                    alt="check-in DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/boxs" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="boxs">
                                  <img
                                    src="../assets/images/menu/Menu-13.webp"
                                    alt="แทงหวย DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-13.webp"
                                    alt="แทงหวย DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/spin" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="spin">
                                  <img
                                    src="../assets/images/menu/Menu-08.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-08.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>


                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/roulet" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="roulet">
                                  <img
                                    src="../assets/images/menu/Menu-09.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-09.webp"
                                    alt="สุ่มเล่นสกิลเกมบนเว็บ DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/gashapon" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="gashapon">
                                  <img
                                    src="../assets/images/menu/Menu-15.webp"
                                    alt="กาชาปอง DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-15.webp"
                                    alt="กาชาปอง DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/huay" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="huay">
                                  <img
                                    src="../assets/images/menu/Menu-12.webp"
                                    alt="แทงหวย DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-12.webp"
                                    alt="แทงหวย DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/paoyingchup" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="paoyingchup">
                                  <img
                                    src="../assets/images/menu/Menu-17.webp"
                                    alt="เป่ายิ้งฉุบ Shiba888 คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-17.webp"
                                    alt="เป่ายิ้งฉุบ Shiba888 คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/huekoy" class="nav-link js-account-approve-aware">
                              <picture>
                                <template v-if="huekoy">
                                  <img
                                    src="../assets/images/menu/Menu-18.webp"
                                    alt="เป่ายิ้งฉุบ Shiba888 คาสิโน บาคาร่าสดออนไลน์"
                                    class="animate__animated animate__pulse animate__infinite img-fluid -img-provider lazyload"
                                  />
                                </template>
                                <template v-else>
                                  <img
                                    src="../assets/images/menu/Menu-18.webp"
                                    alt="เป่ายิ้งฉุบ Shiba888 คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <router-link to="/rewards" class="nav-link js-account-approve-aware">
                              <picture>
                                <template>
                                  <img
                                    src="../assets/images/menu/Menu-10.webp"
                                    alt="แลกของรางวัล DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                            </router-link>
                          </li>
                          <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                              <picture>
                                <template>
                                  <img
                                    src="../assets/images/menu/Menu-19.webp"
                                    alt="แลกของรางวัล DeltaPlus คาสิโน บาคาร่าสดออนไลน์"
                                    class="img-fluid -img-provider lazyload"
                                  />
                                </template>
                              </picture>
                          </li>

                          <!-- <li
                            class="nav-item -random-container -game-slot-macro-container "
                          >
                            <a
                              href="/_ajax_/random?randomCategory=skill-game"
                              class="nav-link js-account-approve-aware"
                              target="_blank"
                              rel="nofollow noopener"
                            >
                              <picture>
                                <img
                                  src="https://ufs888.s3.ap-southeast-1.amazonaws.com/deltaplus/menu/Menu-10.png"
                                  alt="สุ่มเล่นสกิลเกมบนเว็บ Deltaplus คาสิโน บาคาร่าสดออนไลน์"
                                  class="img-fluid -img-provider lazyload"
                                />
                              </picture>
                            </a>
                          </li> -->
                          <!-- <li class="nav-item -random-container -game-slot-macro-container">
                            <div
                              class="x-game-list-item-macro js-game-list-toggle -big "
                              data-status=""
                            >
                              <div class="-inner-wrapper">
                                <picture>
                                  <img
                                    class="img-fluid lazyload"
                                    alt="E.t. Races | wt-evo-play สกิลเกมในเว็บคาสิโนออนไลน์ รับเครดิตฟรีที่ Deltaplus"
                                    src="https://ufs888.s3.ap-southeast-1.amazonaws.com/deltaplus/menu/Menu-03.png"
                                  />
                                </picture>

                               <div class="-overlay">
                                  <div class="-overlay-inner">
                                    <div class="-wrapper-container">
                                      <a
                                        href="/account/lobby/play?channelCode=wt-evo-play&amp;metadata%5Bgame_id%5D=1012"
                                        class="-btn -btn-play js-account-approve-aware"
                                        target="_blank"
                                        rel="nofollow noopener"
                                      >
                                        <i class="fas fa-play"></i>
                                        <span class="-text-btn">เข้าเล่น</span>
                                      </a>
                                      <a
                                        href="/lobby/test?channelCode=wt-evo-play&amp;metadata%5Bgame_id%5D=1012"
                                        class="-btn -btn-demo"
                                        target="_blank"
                                        rel="noopener"
                                      >
                                        ทดลองเล่น
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li> -->
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="-live-feed-wrapper-container js-replace-live-feed-wrapper"
              ></div>
            </div>
          </section>

          <div v-if="showWorldCupEvent" class="worldcup-fab" @click="showWorldCupModal = true">
            <div class="fab-pulse"></div>
            <div class="fab-icon">⚽</div>
            <div class="fab-text">บอลโลก</div>
          </div>

          <div v-if="showWorldCupModal" class="worldcup-modal-overlay" @click.self="showWorldCupModal = false">
            <div class="worldcup-modal">
              <div class="worldcup-modal-header">
                <span>⚽🏆 ทายผลบอลโลก 2026</span>
                <button class="modal-close-wc" @click="showWorldCupModal = false">&times;</button>
              </div>
              <div class="worldcup-modal-body">
                <button class="worldcup-option" @click="goWorldCup">
                  <span class="option-icon">⚽</span>
                  <span>
                    <strong>ทายผลบอล</strong>
                    <small>ฝากครบ 250 วันนี้ ทายคู่พรุ่งนี้ได้</small>
                  </span>
                </button>
                <button class="worldcup-option" @click="goWorldCupRanking">
                  <span class="option-icon">🏆</span>
                  <span>
                    <strong>อันดับ + รับรางวัล</strong>
                    <small>ดูคะแนนสะสมและกดรับเหรียญ</small>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <footerSection></footerSection>
        </div>
      </div>

      <div class="x-right-sidebar-container"></div>

      <div
        class="x-modal modal  "
        id="ads-no-show-again"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-loading-container=".js-modal-content"
        data-ajax-modal-always-reload="true"
        data-modal-one-time="Announcement Banner 1"
        data-check-target="#ads-no-show-again"
      >
        <div class="modal-dialog -modal-size " role="document">
          <div class="modal-content -modal-content">
            <button
              type="button"
              class="close f-1 "
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </button>
            <div class="modal-header -modal-header">
              <h3 class="x-title-modal d-inline-block m-auto">
                <span>📢 ประกาศสำคัญ</span>
              </h3>
            </div>
            <div class="modal-body -modal-body">
              <div class="text-center" v-if="anoucement.image">
                <img
                  :src="anoucement.image"
                  alt="Announcement Deltaplus"
                  class="img-fluid"
                  width="350px"
                />
              </div>
              <br v-if="anoucement.image">
              <div v-html="nl2br(anoucement.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;"></div>
              <AnnouncementVideo :url="anoucement.youtubeUrl" />
              <div class="x-checkbox-primary">
                <div class="text-primary text-center mt-4">
                  <input
                    type="checkbox" v-model="receiveAnounceMent"
                  />&nbsp;&nbsp;&nbsp;&nbsp;
                  <label style="font-size:14px;font-family: 'Kanit', sans-serif;">
                    ไม่ต้องแสดงข้อความนี้อีก
                  </label>
                </div>
              </div>

              <div class="my-3">
                <a
                  @click="submitAnoucement()"
                  data-dismiss="modal"
                  class="text-black btn btn-block -submit btn-primary text-center m-auto"
                >
                  <span>รับทราบ</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from './../router'
import firebase from 'firebase/app'
import moment from 'moment-timezone'
import AnnouncementVideo from '../components/AnnouncementVideo.vue'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    AnnouncementVideo,
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  async mounted () {
    this.$store.dispatch('user/getBanners').catch(err => { console.error(err) })
    this.checkAnoucement()
    await this.checkDeposit()
    await this.checkCashbackYesterday()
    this.checkCheckIn()
    this.checkBoxs()
    this.checkSpin()
    this.checkGashapon()
    this.checkRoulet()
    this.checkCashback()
    this.checkPartner()
    this.checkContinue()
    this.checkHueKoy()
    this.checkPaoYingChup()
    if (Number(moment().tz('Asia/Bangkok').format('D')) === 1 || Number(moment().tz('Asia/Bangkok').format('D')) === 16) {
      if (Number(moment().tz('Asia/Bangkok').format('H') + '' + moment().tz('Asia/Bangkok').format('mm')) <= 1520) {
        this.checkHuay()
      }
    }
    // Snackbar.show({pos: 'top-center',text: 'Example notification text.',actionText:'Click',actionTextColor:'#ffd74c',backgroundColor:'#47124A'});
  },
  computed: {
    showWorldCupEvent () {
      const today = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
      return today >= '2026-06-10' && today <= '2026-07-21'
    },
    banners () {
      return this.$store.state.user.banners
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    user () {
		  return this.$store.state.user.user
    }
  },
  data () {
    return {
      showWorldCupModal: false,
      paoyingchup: false,
      huekoy: false,
      cashback_yesterday: 0,
      deposit: 0,
      continueCheck: false,
      checkin: false,
      partner: false,
      cashback: false,
      roulet: false,
      spin: false,
      huay: false,
      boxs: false,
      gashapon: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      swiperOptions: {
        loop: true,
        speed: 2000,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination'
        }
        // Some Swiper option/callback...
      }
    }
  },
  methods: {
    goWorldCup () {
      this.showWorldCupModal = false
      this.$router.push('/worldcup')
    },
    goWorldCupRanking () {
      this.showWorldCupModal = false
      this.$router.push('/worldcup-ranking')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async moveCreditToWallet () {
      this.$store.commit('user/SET_LOADING', true)
      const user = this.getUserId()
		  this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
      this.$store.dispatch('user/getLastBonus', user).finally(res => {
        this.$store.commit('user/SET_LOADING', false)
        if (this.lastbonus.turncredit) {
          this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
        }
      }).catch(err => { console.error(err) })
	  },
    async clickCheckin () {
      if (this.deposit >= 100 && this.user) {
        firebase.firestore().collection('spin').doc(this.user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-checkin').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            axios({
              method: 'post',
              url: 'https://api.deltaplus-dp.com/qspin/checkin',
              data: {
                key: this.user.key,
                code: this.user.code,
                value: Number(5)
              }
            })
            setTimeout(() => {
              this.$swal({ icon: 'success', title: 'Success', text: 'ท่าน Check-in เรียบร้อยแล้วค่ะ' })
            }, 1000)
          } else {
            this.$swal({ icon: 'error', title: 'Error!', text: 'ท่าน Check-in วันนี้แล้วนะคะรอพรุ่งนี้นะคะ!!!' })
          }
        })
      } else {
        this.$swal({ icon: 'error', title: 'Error!', text: 'ยอดฝากรวมต่อวันครบ 100 Check-In ฟรีจ้า..!!!' })
      }
    },
    async checkPromotions () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/checkPromotions').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    async checkAnoucement () {
      const user = this.getUserId()
      const anoucement = (await firebase.database().ref('/anoucement/1').once('value')).val()
      if (!anoucement || !anoucement.status) return

      const version = String(anoucement.version || 'legacy-1')
      const receipt = (await firebase.database().ref(`/anoucement/receipts/${user.key}`).once('value')).val()
      const legacyAcknowledged = Boolean(anoucement.users && anoucement.users[user.key])

      if (receipt !== version && !legacyAcknowledged) {
        this.anoucement = {
          detail: anoucement.detail || '',
          image: anoucement.image || '',
          youtubeUrl: typeof anoucement.youtubeUrl === 'string' ? anoucement.youtubeUrl : '',
          name: anoucement.name || 'anouncement',
          status: anoucement.status,
          version
        }
        $('#ads-no-show-again').modal('show')
      }
    },
    async checkCashbackYesterday () {
      const user = this.getUserId()
      await firebase.firestore().collection('daily_deposit').doc(user.key + '-' + moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).get().then(async (doc) => {
        if (doc.exists) {
          this.cashback_yesterday = doc.data().cashback
        }
      })
    },
    async checkDeposit () {
      const user = this.getUserId()
      let deposit = 0
      await firebase.firestore().collection('history').where('userkey', '==', user.key).where('type', '==', 'ฝาก').where('status', '==', 'ดำเนินการแล้ว').where('createdate', '>=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 00:00:00').where('createdate', '<=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 23:59:59').get().then(async (snapshot) => {
        snapshot.forEach((doc) => {
          deposit += Number(doc.data().qty)
        })
      })
      this.deposit = deposit
    },
    checkCheckIn () {
      const user = this.getUserId()
      if (this.deposit >= 100) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-checkin').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.checkin = true
          }
        })
      }
    },
    checkBoxs () {
      const user = this.getUserId()
      if (this.cashback_yesterday >= 250) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-boxs').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.boxs = true
          }
        })
      }
    },
    checkGashapon () {
      const user = this.getUserId()
      if (this.cashback_yesterday >= 500) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-gashapon').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.gashapon = true
          }
        })
      }
    },
    checkSpin () {
      const user = this.getUserId()
      if (this.cashback_yesterday >= 500) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.spin = true
          }
        })
      }
    },
    checkRoulet () {
      const user = this.getUserId()
      if (this.cashback_yesterday >= 1000) {
        firebase.firestore().collection('roulet').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.roulet = true
          }
        })
      }
    },
    checkHuay () {
      if (this.deposit >= 150) {
        this.huay = true
      }
    },
    checkCashback () {
      const user = this.getUserId()
      firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.cashback = true
      })
    },
    checkPartner () {
      const user = this.getUserId()
      firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.partner = true
      })
    },
    checkContinue () {
      const user = this.getUserId()
      firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
        if (snapshot.size) this.continueCheck = true
      })
    },
    async submitAnoucement () {
      if (this.receiveAnounceMent) {
        const user = this.getUserId()
        await firebase.database().ref(`/anoucement/receipts/${user.key}`).set(
          this.anoucement.version || 'legacy-1'
        )
      }
    },
    async checkHueKoy (){
      const user = this.getUserId()
      if (this.cashback_yesterday > 0) {
        await firebase.firestore().collection('daily_deposit').doc(user.key + '-' + moment().tz('Asia/Bangkok').add(-2, 'days').format('YYYY-MM-DD')).get().then(async (doc) => {
          if (doc.exists) {
            if(doc.data().cashback > 0 && (Number(this.cashback_yesterday) + Number(doc.data().cashback) >= 300)){
              this.huekoy = true
            }
          }
        })
      }
    },
    checkPaoYingChup () {
      const user = this.getUserId()
      if (this.cashback_yesterday >= 1000) {
        firebase.firestore().collection('spin').doc(user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + '-paoyingchup').get().then(async (snapshot) => {
          if (!snapshot.exists) {
            this.paoyingchup = true
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.x-modal .-modal-content .-modal-body {
     top: 10px;
}
@media (max-width: 575.98px) {
  .x-modal .-modal-content .-modal-body {
     top: 90px;
  }
}

/* ===== WORLD CUP ENTRY ===== */
.worldcup-fab {
  position: fixed;
  right: 16px;
  bottom: 88px;
  z-index: 1030;
  width: 82px;
  height: 82px;
  border-radius: 50%;
  background: linear-gradient(145deg, #f2c94c, #1856b3);
  border: 2px solid rgba(255,255,255,0.35);
  box-shadow: 0 10px 28px rgba(0,0,0,0.35), 0 0 22px rgba(242, 201, 76,0.34);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'Kanit', sans-serif;
}
.fab-pulse {
  position: absolute;
  inset: -7px;
  border-radius: 50%;
  border: 2px solid rgba(242, 201, 76,0.45);
  animation: worldCupPulse 1.9s ease-out infinite;
}
.fab-icon { font-size: 28px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.45)); }
.fab-text { margin-top: 4px; font-size: 13px; font-weight: 800; text-shadow: 0 1px 4px rgba(0,0,0,0.5); }
@keyframes worldCupPulse {
  0% { transform: scale(0.84); opacity: 0.85; }
  100% { transform: scale(1.25); opacity: 0; }
}
.worldcup-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background: rgba(0,0,0,0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
}
.worldcup-modal {
  width: min(420px, 100%);
  overflow: hidden;
  border-radius: 18px;
  background: #11172c;
  border: 1px solid rgba(242, 201, 76,0.45);
  box-shadow: 0 18px 48px rgba(0,0,0,0.45);
  font-family: 'Kanit', sans-serif;
}
.worldcup-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  color: #fff;
  font-weight: 900;
  background: linear-gradient(135deg, #f2c94c, #1856b3);
}
.modal-close-wc {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: rgba(0,0,0,0.22);
  color: #fff;
  font-size: 24px;
  line-height: 1;
}
.worldcup-modal-body {
  display: grid;
  gap: 10px;
  padding: 14px;
}
.worldcup-option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 74px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.07);
  color: #fff;
  text-align: left;
}
.worldcup-option strong { display: block; font-size: 16px; line-height: 1.2; }
.worldcup-option small { display: block; margin-top: 4px; color: rgba(255,255,255,0.68); font-size: 12px; }
.option-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: rgba(242, 201, 76,0.18);
  font-size: 24px;
}
@media (max-width: 575.98px) {
  .worldcup-fab {
    right: 12px;
    bottom: 78px;
    width: 72px;
    height: 72px;
  }
  .fab-icon { font-size: 24px; }
  .fab-text { font-size: 12px; }
}
</style>
